// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__LQLoi","inputWrap":"styles_inputWrap__2xb4R","input":"styles_input__1thQv"};